// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__PageSwitcherNavigation__navigation__fRirQy{display:flex;gap:var(--JDS-PAGINATION-CONTROLS-GAP-INTERNAL)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/Table/internal/PageSwitcherNavigation/PageSwitcherNavigation.module.css"],"names":[],"mappings":"AAAA,iDACE,YAAA,CACA,+CAAA","sourcesContent":[".navigation {\n  display: flex;\n  gap: var(--JDS-PAGINATION-CONTROLS-GAP-INTERNAL);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": "jut__PageSwitcherNavigation__navigation__fRirQy"
};
export default ___CSS_LOADER_EXPORT___;
